var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.report)?_c('div',_vm._l((_vm.components),function(c){return _c(c.name,_vm._b({key:c.page,tag:"component",style:(_vm.style)},'component',_vm.reportPageBinding(c.page, c.name),false))}),1):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }